import NotificationSnackbar from './notification-snackbar'

export default NotificationSnackbar